import React from 'react';
import { MapPin } from 'lucide-react';
import { Card } from './ui/card';

const PortoSeguroPackages = ({ onOpenForm }) => {
  const photos = [
    {
      url: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/t2991gzr_GRUPO%20A%20AGENCIA%20NA%20PASSARELA%20DO%20ALCOOL.jpeg',
      title: 'Passarela da Cultura',
      description: 'Noite animada na Passarela do Álcool'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/q4a1cib8_GRUPO%20DA%20AGENCIA%20NO%20CENTRO%20HISTORICO.jpeg',
      title: 'Centro Histórico',
      description: 'Visitando o patrimônio de Porto Seguro'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/n5igpztr_Grupo%20de%20Agosto%20em%20Trancoso.jpeg',
      title: 'Trancoso',
      description: 'Belezas naturais da região'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/1mthz7r8_GRUPO%20NA%20PASSARELA%20DO%20ALCOOL.jpeg',
      title: 'Grupo A.R.',
      description: 'Momentos inesquecíveis'
    }
  ];

  return (
    <section id="pacotes" className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full mb-3">
            <MapPin className="w-4 h-4" />
            <span className="font-semibold text-sm">Nosso Destino</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Experiência em <span className="text-red-600">Porto Seguro</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Viagens com guias especializados • Centro Histórico • Passarela da Cultura
          </p>
        </div>

        {/* Photo Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-6">
          {photos.map((photo, index) => (
            <Card 
              key={index}
              className="overflow-hidden border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
              onClick={onOpenForm}
            >
              <div className="relative h-40 md:h-72 overflow-hidden">
                <img
                  src={photo.url}
                  alt={photo.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-5 text-white">
                  <h3 className="text-sm md:text-xl font-bold mb-0.5 md:mb-1">{photo.title}</h3>
                  <p className="text-gray-200 text-xs md:text-sm hidden md:block">{photo.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortoSeguroPackages;
